import React from "react";
import HostDashboard from "./host-dashboard";

export const HostDashboardRoutes = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "host-dashboard",
      element: <HostDashboard />,
    },
  ],
};
